import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseRequestListComponent } from '../base-request-list/base-request-list.component';
import { CommonGridComponent, GridColumn, GridAction } from '../../../shared/components/common-grid/common-grid.component';
import { RequestManagementService, PaginationInfo, RequestTask } from '../../../shared/services/request-management.service';


@Component({
  selector: 'app-my-sent',
  standalone: true,
  imports: [CommonModule, TranslateModule, CommonGridComponent],
  templateUrl: './my-sent.component.html',
  styleUrls: ['./my-sent.component.scss']
})
export class MySentComponent extends BaseRequestListComponent implements OnInit {
  
  /**
   * Define columns for my sent grid
   */
  columns: GridColumn[] = [
    { key: 'number', label: 'Request Number', translationKey: 'requests.number' },
    {
      key: 'module',
      label: 'Module',
      translationKey: 'requests.module',
      type: 'custom',
      customRender: (value: any) => this.translate.instant(`workflow_types.${value}`)
    },
    { key: 'createdDate', label: 'Sent Date', translationKey: 'requests.sentDate', type: 'date' },
    {
      key: 'status',
      label: 'Status',
      translationKey: 'requests.status',
      type: 'badge'
    }
  ];

  /**
   * Define actions available for my sent requests
   */
  actions: GridAction[] = [
    { 
      id: 'view', 
      label: 'common.view', 
      type: 'view', 
      icon: 'bi-eye'
    }
    //,
    // { 
    //   id: 'edit', 
    //   label: 'common.edit', 
    //   type: 'edit', 
    //   icon: 'bi-pencil',
    //   condition: (row: RequestTask) => row.status === 'Draft'
    // },
    // { 
    //   id: 'resend', 
    //   label: 'requests.resend', 
    //   type: 'resend', 
    //   icon: 'bi-arrow-repeat'
    // },
    // { 
    //   id: 'delete', 
    //   label: 'common.delete', 
    //   type: 'delete', 
    //   icon: 'bi-trash'
    // }
  ];

  constructor(
    private requestService: RequestManagementService,
    private router: Router,
    private translate: TranslateService
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  /**
   * Fetch my sent requests
   */
  override fetchRequests(pageNumber: number, delegationId?: number): void {
    this.loadingSubject$.next(true);

    const paginationInfo: PaginationInfo = this.buildPaginationInfo(pageNumber);

    this.requestService.getMySent(paginationInfo, delegationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.updateRequests(response);
          this.loadingSubject$.next(false);
        },
        error: (error) => {
          this.handleError(error);
        }
      });
  }

  /**
   * Open the request when its row is clicked
   */
  onRowClick(row: any): void {
    this.viewRequest(row);
  }

  /**
   * Handle action triggered from grid
   */
  onTableAction(event: { action: GridAction; row: any }): void {
    switch (event.action.type) {
      case 'view':
        this.viewRequest(event.row);
        break;
      case 'edit':
        this.editRequest(event.row);
        break;
      case 'resend':
        this.resendRequest(event.row);
        break;
      case 'delete':
        this.deleteRequest(event.row);
        break;
    }
  }

  /**
   * View request details in task viewer
   */
  private viewRequest(row: any): void {
    if (row?.id && row?.taskId) {
      this.router.navigate(['/requests/task-view', 3, row.id, row.taskId]);
    } else {
      console.warn('Cannot navigate to task viewer: missing request or task ID', row);
    }
  }

  /**
   * Edit draft request
   */
  private editRequest(row: any): void {
    if (row?.id && row?.taskId) {
      this.router.navigate(['/requests/task-view', 3, row.id, row.taskId]);
    } else {
      console.warn('Cannot navigate to task viewer: missing request or task ID', row);
    }
  }

  /**
   * Resend request
   */
  private resendRequest(row: any): void {
    console.log('Resend request:', row);
    // Call API to resend request
  }

  /**
   * Delete request
   */
  private deleteRequest(row: any): void {
    console.log('Delete request:', row);
    // Show confirmation dialog and delete
  }
}
